import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {DISABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import Utils from '../../../utils/Utils';
import logger from 'src/utils/logger/logger';

class FastPlayChannelsTask extends AbstractRequestTask {
  constructor(params) {
    super();
    this.stream_type = params.streamType;
    this._params = {
      payway_tokens: params.paywayTokens,
      group_ids: params.groupIds,
    };
  }

  getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");
      let _url = `${http}${url}/services/player/v1/assets?`;
      _url += Utils.buildQueryParams(this.getGETParams());
      return _url;
  }

  isValid() {

    return true;
  }

  getParams() {
    const user_token = super.getParams().user_token;
    logger.debug("@@@ THIS._params:", this._params)
    logger.debug("@@@ payway_tokens:", this._params.payway_tokens)
    return {...this._params, user_token};
  }

  getHeaders() {
    return {};
  }

  getGETParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.api_version;
    delete params.user_token;
    return  {
        stream_type: this.stream_type,
        ...params,
    };
  }

  getRetriesNumber() {
    return 0;
  }

  getMethod() {
    return 'POST';
  }

  success(data, b) {
    logger.debug("@@@ DATA INSIDE REQUEST")
    this.resolve(data);
  }

  getEncType() {
    if (this.getMethod() === "POST") return "multipart/form-data";

    return "application/x-www-form-urlencoded";
  }

  getShowErrorModal(){
		return DISABLE_MODAL_RETRIES;
	}
}

export default FastPlayChannelsTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/player/FastPlayChannelsTask.js